import * as React from 'react';
import clsx from 'clsx';
import { useOverflow } from '../../hooks';
import { Base } from '../Base';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "DrawerContent-root_3SykV",
  "scroller": "DrawerContent-scroller_2K73w",
  "scrollMarks": "DrawerContent-scrollMarks_DJk9e",
  "overflowTop": "DrawerContent-overflowTop_3roxt",
  "overflowBottom": "DrawerContent-overflowBottom_XWTKx"
};
function DrawerContent({
  children,
  className,
  ...extraProps
}) {
  const {
    hasOverflowTop,
    hasOverflowBottom,
    contentRef,
    scrollerRef,
    scrollerProps
  } = useOverflow();
  return /*#__PURE__*/_jsx(Base, {
    tagName: "section",
    flexAuto: true,
    backgroundColor: "white",
    className: clsx(styles.root, styles.scrollMarks, {
      [styles.overflowTop]: hasOverflowTop,
      [styles.overflowBottom]: hasOverflowBottom
    }, className),
    ...extraProps,
    children: /*#__PURE__*/_jsx("div", {
      ref: scrollerRef,
      className: styles.scroller,
      ...scrollerProps,
      children: /*#__PURE__*/_jsx("div", {
        ref: contentRef,
        children: children
      })
    })
  });
}
export default DrawerContent;